import { FDSelectInput } from '@facet-wealth/design';
import React, { useCallback } from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';

const isEmpty = (value) => value === '' || value === undefined || (Array.isArray(value) && value.length === 1 && value[0] === '');

const SelectInput = (props) => {
  const {
    alignSelf,
    flex,
    flexGrow,
    flexShrink,
    fullWidth,
    disabled,
    error,
    helperTextValue,
    label,
    onBlur,
    onChange,
    onFocus,
    options,
    placeholder,
    readonly,
    multiple,
    size,
    value,
    required,
    labelPlacement,
    ...rest
  } = props;

  const zeroValue = multiple ? [] : undefined;
  const onChangeImproved = useCallback((val) => {
    if (isEmpty(val)) {
      if (multiple) onChange([]);
      else onChange('');
    } else {
      onChange(val);
    }
  }, [multiple, onChange]);

  return (
    <FDSelectInput
      {...useDataAttrs(rest)}
      alignSelf={alignSelf}
      disabled={disabled || readonly}
      error={error}
      flex={flex}
      flexGrow={flexGrow}
      flexShrink={flexShrink}
      fullWidth={fullWidth}
      helperText={helperTextValue}
      label={label}
      onBlur={onBlur}
      onChange={onChangeImproved}
      onFocus={onFocus}
      options={options}
      placeholder={placeholder}
      size={size}
      value={isEmpty(value) ? zeroValue : value}
      labelPlacement={labelPlacement}
      multiple={multiple}
      required={required}
    />
  );
};

SelectInput.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flex: inputDefaultProps.flex,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  placeholder: inputDefaultProps.placeholder,
  readonly: inputDefaultProps.readonly,
  value: undefined,
  required: inputDefaultProps.required,
  multiple: false,
};

SelectInput.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flex: inputPropTypes.flex,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: inputPropTypes.label,
  placeholder: inputPropTypes.placeholder,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: PropTypes.oneOf([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  required: inputPropTypes.required,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  labelPlacement: inputPropTypes.labelPlacement,
  multiple: PropTypes.bool,
  readonly: inputPropTypes.readonly,
  options: inputPropTypes.options.isRequired,
};

const SelectInputSmall = (props) => {
  return <SelectInput {...props} size="sm" />;
};

const SelectInputLarge = (props) => {
  return <SelectInput {...props} size="lg" />;
};

export { SelectInputSmall, SelectInputLarge };
